var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"company-auth"},[_c('div',{staticClass:"header"},[_c('mm-steps',{attrs:{"current":_vm.step}},[_c('mm-step',{attrs:{"title":_vm.$t('auth.step1')}}),_c('mm-step',{attrs:{"title":_vm.$t('auth.step2')}}),_c('mm-step',{attrs:{"title":_vm.$t('auth.step3')}})],1)],1),_c(_vm.stepCom,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }